import { KpiService } from "@gtmhub/kpis";
import { providerUpgradeFactory } from "@webapp/core/provider-upgrade/factories/provider-upgrade.factory";

/**
 * @deprecated This class is deprecated. Please use KpiFacade.
 */
export const KpiServiceProvider = {
  provide: KpiService,
  useFactory: providerUpgradeFactory("KpiService"),
  deps: ["$injector"],
};
